import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import { Check as CopiedIcon, ContentCopy as CopyIcon } from '@mui/icons-material';

interface Props {
  label: string;
  value: string;
  /** Several lines, for a long filter query. */
  multiline?: boolean;
}

/** A read-only value with a button that copies it. */
const CopyField: React.FC<Props> = ({ label, value, multiline = false }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard access refused: the text can still be selected by hand.
    }
  };
  return (
    <TextField
      label={label}
      value={value}
      size="small"
      fullWidth
      multiline={multiline}
      maxRows={4}
      InputProps={{
        readOnly: true,
        sx: { fontFamily: 'monospace', fontSize: '0.875rem' },
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={copied ? 'Copied' : 'Copy'}>
              <IconButton size="small" edge="end" onClick={copy} aria-label={`Copy ${label.toLowerCase()}`}>
                {copied ? <CopiedIcon fontSize="small" color="success" /> : <CopyIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
      onFocus={(e) => e.target.select()}
    />
  );
};

export default CopyField;
